import { getAuth } from '@lib/api';
import { defaultFetch } from './baseApi';

const baseURL = process.env.REACT_APP_BASE_URL;

export type ProjectTrackRecordType = {
	id: string;
	name: string;
	file: string;
	log: null;
	projectId: number;
	firstExport: number;
	createdAt: string;
	updatedAt: string;
};

export const getProjectTrackRecords = async (projectId: string) =>
	defaultFetch<ProjectTrackRecordType[]>(`/v0/projects/${projectId}/trackrecords`);

export type ProjectAggregateTrackRecordType = {
	id: string;
	name: string;
	file: string;
	log: null;
	projectaggregateId: number;
	firstExport: number;
	createdAt: string;
	updatedAt: string;
};

export const getProjectAggregateTrackRecords = async (projectAggregateId: string) =>
	defaultFetch<ProjectAggregateTrackRecordType[]>(`/v0/projectaggregates/${projectAggregateId}/trackrecords`);

export const generateTrackRecordTemplates = async (
	entityType: 'projects' | 'projectaggregates',
	entityId: string,
	configurationId: string,
	output: string,
	files: File[],
	fileTypes: string[],
	trackName?: string,
) => {
	const formData = new FormData();
	files.forEach((file, i) => {
		formData.append(`files[${i}]`, file);
	});
	fileTypes.forEach((fileType, i) => {
		formData.append(`fileTypes[${i}]`, fileType);
	});
	formData.append('configurationId', configurationId);
	formData.append('output', output);
	if (trackName) {
		formData.append('track_name', trackName);
	}

	const token = getAuth();

	return (
		await fetch(`${baseURL}/v0/${entityType}/${entityId}/generatetemplates`, {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${token}`,
			},
			body: formData,
		})
	).json();
};
